import { useNavigate } from 'react-router';
import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { PatchCategoryDto } from '../../../commonTypes/user.types';

const useHttpUpdateCategory = () => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, body: PatchCategoryDto) => {
        const { exec, abort } = userApi.editDocumentCategory({
            params: { id: id },
            body: body,
            onSuccess: () => {
                toastHandler.push('success', t('categories.updateTitle'), t('categories.updateMessage_Success'));
                navigate(`/documents`);
            },
            onError: () => toastHandler.push('error', t('categories.updateTitle'), t('categories.updateMessage_Failed')),
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpUpdateCategory;
